import React, { FC, useCallback, useState } from "react";

import { Modal } from "../../common";
import { InvoicingDetailsForm } from "../../forms/InvoicingDetailsForm";
import { DecisionDialog } from "../../common/DecisionDialog";

/*
  TODO: Refactor accordingly to support the following use cases:

  x Add account details standalone
  - Add client details standalone
  - Add contractor details standalone

  - Add account details as client to invoice
  - Add account details as contractor to invoice
*/

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const InvoicingDetailsModal: FC<Props> = ({ isOpen, onClose }) => {
  const [showConfirmCloseModal, setShowConfirmCloseModal] = useState(false);
  const [formHasChanged, setFormHasChanged] = useState(false);

  const requestClose = useCallback(() => {
    if (formHasChanged) {
      setShowConfirmCloseModal(true);
      return;
    }

    onClose();
  }, [formHasChanged, onClose]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        close={requestClose}
        title="Your details"
        subtitle="We will save it to fill invoices as default, you can edit any time"
      >
        <InvoicingDetailsForm
          onSuccess={onClose}
          onChange={() => !formHasChanged && setFormHasChanged(true)}
        />
      </Modal>

      <DecisionDialog
        isOpen={showConfirmCloseModal}
        title="Are you sure you want to leave?"
        cancel={{
          label: "No, back to edit details",
          onClick: () => setShowConfirmCloseModal(false),
        }}
        proceed={{
          label: "Yes, leave",
          onClick: onClose,
        }}
      >
        The progress will be lost
      </DecisionDialog>
    </>
  );
};
